import { render, staticRenderFns } from "./Side-Admin-Custom-Group.vue?vue&type=template&id=e323e9a4&"
import script from "./Side-Admin-Custom-Group.vue?vue&type=script&lang=js&"
export * from "./Side-Admin-Custom-Group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports